const DOCUMENT_DISCRIMINATOR_TAG_SCOPE = 'document-discriminator-tag';

export const DocumentDiscriminatorTagTestIds = {
  getTagId: documentId => `${DOCUMENT_DISCRIMINATOR_TAG_SCOPE}.tag-${documentId}`,
};
